<template>
  <div>
    <div class="d-flex">
      <CButton
        :disabled="loading"
        class="headerActions__button"
        v-c-tooltip="{ content: 'Approve', placement: 'top' }"
        @click.stop=""
        v-c-emit-root-event:approveOrReprove="{ status: 2, reasonText: 'reasonText' }"
      >
        <CIcon name="approvedFull" class="text-success" size="custom-size" :height="25" viewBox="0 0 32 32" />
      </CButton>
      <CButton
        :disabled="loading"
        class="headerActions__button"
        v-c-tooltip="{ content: 'Refuse', placement: 'top' }"
        @click.stop="statePopUpSenderRequest = !statePopUpSenderRequest"
      >
        <CIcon name="refusedFull" class="text-danger" size="custom-size" :height="25" viewBox="0 0 32 32" />
      </CButton>
    </div>

    <transition name="fade" v-if="statePopUpSenderRequest">
      <div class="dataTable__popUp popUp" @click.stop.stop style="max-width: 250px">
        <div class="popUp__body shadow-sm px-0 pt-4">
          <h5 class="mb-2 px-4">The reason</h5>
          <ul class="p-0 m-0 list overflow-auto">
            <li @click="setReason('Not authorized by operators')" class="d-flex justify-content-between align-items-center py-2 px-4 list__item">
              <span>Not authorized by operators</span>
            </li>
            <li @click="setReason('Not available')" class="d-flex justify-content-between align-items-center py-2 px-4 list__item">
              <span>Not available</span>
            </li>
            <li @click="openCustomReason" class="d-flex justify-content-between align-items-center py-2 px-4 list__item">
              <span>Custom reason</span>
            </li>
          </ul>
        </div>
      </div>
    </transition>
    <transition name="fade" v-if="customModal">
      <div class="dataTable__popUp popUp" @click.stop.stop style="margin-top: 0px; margin-left: 270px">
        <div class="popUp__body shadow-sm">
          <div class="confirmationDelete">
            <div class="confirmationDelete__header">
              <p class="confirmationDelete__title font-weight-semi-bold mb-1">Reason</p>
            </div>
            <div class="confirmationDelete__body mb-4">
              <p v-if="defaultReason" class="text-gray-700">
                {{ reasonText }}
              </p>

              <textarea v-else class="form-control" v-model="reasonText" maxlength="70" placeholder="Write here"></textarea>
            </div>
            <div class="confirmationDelete__footer">
              <div class="confirmationDelete__actions">
                <CButton class="confirmationDelete__btn btn btn-primary" :disabled="reasonText.length < 3 && loading" @click="sendReasonCustom">
                  confirm
                </CButton>
                <CButton class="confirmationDelete__btn" @click="closeCustomReason" type="link"> Cancel </CButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'SenderRequest',
  props: {
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      color: null,
      reasonText: '',
      customModal: false,
      reasonId: null,
      statePopUpSenderRequest: false,
      defaultReason: true,
    }
  },

  created() {
    this.$root.$on('update-close-popup', () => {
      this.closePopUp()
    })
  },

  computed: {
    valueReasonText() {
      return this.reasonText
    },
  },

  methods: {
    setColor(val) {
      this.color = val ? 'success' : 'danger'
      return val
    },

    closePopUp() {
      this.statePopUpSenderRequest = false
      this.customModal = false
    },

    openCustomReason() {
      this.customModal = true
      this.defaultReason = false
      this.reasonText = ''
    },

    closeCustomReason() {
      this.customModal = false
      this.statePopUpSenderRequest = false
    },

    setReason(reasonId) {
      this.reasonText = reasonId
      this.customModal = true
      this.defaultReason = true
      this.statePopUpSenderRequest = true
    },

    sendReasonCustom() {
      this.$emit('sendApproveOrReprove', { status: 3, reasonText: this.reasonText })
      this.closeCustomReason()
    },
  },
}
</script>

<style lang="scss" scope>
.list {
  max-height: 300px;
  overflow-x: scroll;
  &__item {
    color: var(--gray-700);

    &:hover {
      background: transparentize($primary, 0.75);
    }
  }

  /* width */
  &::-webkit-scrollbar {
    width: 5px;
  }

  /* Track */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
  }

  /* Handle */
  &::-webkit-scrollbar-thumb {
    background: var(--gray-500);
  }

  /* Handle on hover */
  &::-webkit-scrollbar-thumb:hover {
    background: #f1f1f1;
  }
}
</style>
